import React from 'react'
import './reportclaims.scss'
import { Row, Col } from 'react-bootstrap'
const ReportClaims = () => {
  return (
    <>
      <div className='report-claim-main'>
        <Row>
          <Col sm={12} md={7} lg={8} xl={8}>
            <div className='left-details'>
              <div className='Heading'>
                <h3>Our claims services department is dedicated to taking care of you.</h3>
              </div>
              <div className='text'>
                <p>Claims happen—that’s why you insure your business. And when they do happen, we work to resolve your claims efficiently and fairly so you can get back to focusing on your business and your future.</p>
                <p>You’re supported by a team of experienced claims professionals committed to serving you. Our execution, customer service, communication, and solution-oriented approach keep the entire claims process moving along efficiently.</p>
              </div>
            </div>
          </Col>
          <Col sm={12} md={5} lg={4} xl={4}>
            <div className='report-claim-right'>
              <h3>Report a claim</h3>
              <p>Report a claim over the phone or by logging in to your account. If you need help, or have questions, call us at <strong>800-473-6879</strong> to speak with one of our knowledgeable claims representatives.</p>
              <button className='report-btn'>Report a claim</button>
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default ReportClaims